import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', 
        display: 'flex', 
        flexDirection: 'column', 
        color: '#fff', 
        fontFamily: 'Montserrat, sans-serif', 
        fontSize: 16, 
        borderBottom: '1px solid rgba(0,0,0,.3)', 
        width: '100%', 
        textAlign: 'center', 
        paddingTop: 20, 
        paddingBottom: 20
    },
    date: {
        position: 'absolute', 
        top: 10, 
        left: 10, 
        fontSize: 14, 
        color: '#14c0e9'
    },
    type: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        fontSize: 14, 
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255,.3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    wrapLogin: {
        margin: '12px 0'
    },
    wrapImage: {
        padding: '0 20px'
    },
    image: {
        width: '100%', 
        height: 100, 
        objectFit: 'cover',
    },
    wrapBtn: {
        marginTop: 12
    },
    success: {
        padding: 10,
        background: '#3cde0b',
        color: 'rgb(36, 38, 62)',
        fontWeight: 700,
        borderRadius: 4,
        marginRight: 8,
        cursor: 'pointer',
    },
    cancel: {
        padding: 10,
        background: 'rgb(142, 22, 0)',
        color: 'rgb(232, 232, 232)',
        fontWeight: 700,
        borderRadius: 4,
        marginRight: 8,
        cursor: 'pointer',
    },
    dialogImage: {
        display: 'block', 
        width: '100%', 
        height: '100%'
    }
}))

const getTypes = (types) => {
    switch (types) {
        case 'passport': return 'Паспорт';
        case 'selfie_passport': return 'Селфи с паспортом';
        case 'selfie_card': return 'Селфи с картой';
        case 'photo_window_passport': return 'Фото паспорта';
        default: return 'Неизвестно'
    }
}

const getDate = (value) => {
    const date = new Date(moment.utc(+value))

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const min = date.getMinutes();

    const formatterDay = day < 10 ? '0' + day : day;
    const formatterMonth = month < 10 ? '0' + month : month;
    const formatterHours = hours < 10 ? '0' + hours : hours;
    const formatterMinutes = min < 10 ? '0' + min : min;
    
    return `${formatterDay}.${formatterMonth}.${year} ${formatterHours}:${formatterMinutes}`
}

export {
    getTypes,
    getDate,
    useStyles
}